export class WebinarCounter {

    private element: HTMLElement;
    private counterParts: Object = {};

    private texts: Object;
    private timestamp: number;

    constructor(counterElement: HTMLElement) {
        this.element = counterElement;
        this.texts = JSON.parse(counterElement.getAttribute('data-texts'));
        this.timestamp = parseInt(counterElement.getAttribute('data-timestamp'));

        this.render();
    }
    getNumbers() {

        const now = Math.round(Date.now() / 1000);
        const diff: number = this.timestamp - now;

        const days = Math.floor(diff / (60 * 60 * 24));
        const hours = Math.floor((diff - days * (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.round((diff - days * (60 * 60 * 24) - hours * (60 * 60)) / (60));

        return {
            days,
            hours,
            minutes
        };
    }

    render() {
        const numbers = this.getNumbers();

        if (numbers.days < 0 && this.element) {
            this.element.parentElement.removeChild(this.element);
            this.element = null;
            return;
        }

        Object.entries(numbers).forEach(([unit, number]) => {
            this.counterParts[unit] = this.counterParts[unit] || {
                number: this.element.querySelector('.' + unit + ' .number'),
                unit: this.element.querySelector('.' + unit + ' .unit'),
            };

            this.counterParts[unit].number.textContent = number;
            this.counterParts[unit].unit.textContent = this.getText(number, unit);

            if ( unit === "minutes" && number === 60 ) {
                this.counterParts['hour'].number.textContent = this.counterParts['hour'].number.textContent+1;
                this.counterParts['hour'].unit.textContent = this.getText(number, unit);
                this.counterParts[unit].number.textContent = 0;
                this.counterParts[unit].unit.textContent = this.getText(number, unit);
            }
        });

    }

    getText(number, unit) {
        if (number === 1) {
            return this.texts[unit][0];
        }

        if (number % 10 > 1 && number % 10 < 5 && Math.floor(number / 10) !== 1) {
            return this.texts[unit][1];
        }

        return this.texts[unit][2];
    }


}

export class WebinarCounters {

    private counterElements: NodeListOf<HTMLElement>;
    private counters: Array<WebinarCounter> = [];
    private interval: Number|NodeJS.Timer;

    init() {

        this.counterElements = document.querySelectorAll('.featured-webinar__counter');
        this.counterElements.forEach((element, index) => {
            this.counters[index] = new WebinarCounter(element);
        });

        this.interval = setInterval(() => {
            this.counters.forEach(counter => counter.render());
        }, 1000 * 60);

    }



}
